import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 無論環境都強制啟用測試模式
console.log('🔧 強制啟用測試模式');
localStorage.setItem('test_mode', 'true');

// 測試模式便捷函數
window.enableTestMode = function (enable = true) {
    if (enable) {
        localStorage.setItem('test_mode', 'true');
        console.log('✅ 測試模式已啟用 - 無需後端 API');
    } else {
        localStorage.removeItem('test_mode');
        console.log('❌ 測試模式已停用 - 需要後端 API');
    }
    window.location.reload();
};

window.getTestUsers = function () {
    console.log('可用的測試帳號:');
    console.log('- 管理員: admin / admin123');
    console.log('- 車隊經理: manager / manager123');
    console.log('- 調度員: dispatcher / dispatch123');
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();